import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LinkService {
    private static readonly URL_BASE_STORE_APPOINTMENT: string =
        'https://boutiques.bouyguestelecom.fr/bouyguestelecom/fr?origin=web_b2c_';

    public static getStoreApointmentLink(pageName: string): string {
        return `${this.URL_BASE_STORE_APPOINTMENT}${pageName}`;
    }
}
